import { Component, OnInit } from '@angular/core';
import { Helper } from '../../helpers/helper';
import { ReportesService } from '../../services/reportes.service';

@Component({
  selector: 'app-solicitar-prestamo',
  templateUrl: './solicitar-prestamo.component.html',
  styleUrls: ['./solicitar-prestamo.component.css']
})
export class SolicitarPrestamoComponent implements OnInit {
  fecha = new Date();
  compania: string;

  constructor(
    public helper: Helper,
    private reportesService: ReportesService
  ) {
    setInterval(() => {
      this.fecha = new Date();
    }, 1000);
  }

  ngOnInit() {
    this.initCompanias();
  }

  private initCompanias() {
    this.reportesService.compania().subscribe((res: any) => {
      this.compania = res.descripcion;
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/pages/solicitar-prestamo/solicitar-prestamo.component.ts